import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { ManagementUser } from '../../../core/models/management-user.model';
import { SchoolAdminTeacherFilterService } from './school-admin-teacher-filter.service';
import { ReportsService } from 'src/app/core/services/reports.service';
import { SessionStorageService } from 'src/app/core/services/session-storage.service';

@Component({
  selector: 'wf-school-admin-teacher-filter',
  templateUrl: './school-admin-teacher-filter.component.html',
  standalone: false
})
export class SchoolAdminTeacherFilterComponent implements OnInit {
  @Input() label: string = 'Teacher';
  @Input() required: boolean = false;
  @Input() disabled: boolean = false;
  @Input() allowAllOption: boolean = false;
  @Output() teacherChange = new EventEmitter<number>();

  teachers: ManagementUser[] = [];
  selectedTeacherId: number | null = null;

  constructor(
    private teacherFilterService: SchoolAdminTeacherFilterService,
    private sessionStorageService: SessionStorageService,
  ) {}

  ngOnInit(): void {
    const teacherFilter = this.sessionStorageService.getSchoolAdminTeacherFilter();
    this.teachers = this.teacherFilterService.sortTeachers(teacherFilter?.teachers ?? []);

    const savedSelectedTeacherId = teacherFilter?.selectedTeacherId ?? null;
    if (this.allowAllOption) {
      this.selectedTeacherId = savedSelectedTeacherId;
      return;
    }

    this.selectedTeacherId = savedSelectedTeacherId != null && savedSelectedTeacherId > 0
      ? savedSelectedTeacherId
      : this.teachers[0]?.userID ?? null;

    if (this.selectedTeacherId !== savedSelectedTeacherId) {
      this.updateSessionStorage();
    }
  }

  onTeacherChange(teacherId: number) {
    this.selectedTeacherId = teacherId;
    this.updateSessionStorage();
    this.teacherChange.emit(teacherId);
  }

  private updateSessionStorage() {
    this.sessionStorageService.setSchoolAdminTeacherFilter({
      teachers: this.teachers,
      selectedTeacherId: this.selectedTeacherId,
    });
  }
}
